import { render, staticRenderFns } from "./EmployeeEducationDetailTable.vue?vue&type=template&id=1d94b8d8&scoped=true&"
import script from "./EmployeeEducationDetailTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducationDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d94b8d8",
  null
  
)

export default component.exports